import dynamic from 'next/dynamic';

export { BuyButton } from './BuyButton';
export { ColorBox } from './ColorBox';
export { CustomizationPopUp } from './CustomizationPopUp';
export { ProductDetails } from './ProductDetails';
export { ProductSlides } from './ProductSlides';
export { VariantBox } from './VariantBox';
export { QuantityBox } from './QuantityBox';

export const RatingSection = dynamic(() => import('components/products/RatingSection'));
export const SimilarProducts = dynamic(() => import('components/products/SimilarProducts'));
